module.exports = __webpack_public_path__ + "static/img/machine-hand.0878ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/machine-hand.png
// module id = FoYG
// module chunks = 1